/* eslint-disable dot-notation */
import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import {
  formField,
  formModel,
} from '../../../utilities/form-mapper/annotations';

function dateAndTimeAfter(
  startDateControlName: string,
  startTimeControlName: string,
  endDateControlName: string,
  endTimeControlName: string,
): ValidatorFn {
  return (control: AbstractControl) => {
    const startDate = control.get(startDateControlName)?.value as Date | null;
    const startTime = control.get(startTimeControlName)?.value as Date | null;
    const endDate = control.get(endDateControlName)?.value as Date | null;
    const endTime = control.get(endTimeControlName)?.value as Date | null;

    if (!startDate || !startTime || !endDate || !endTime) {
      return null;
    }

    const startDateTime = new Date(startDate);
    startDateTime.setHours(
      startTime.getHours(),
      startTime.getMinutes(),
      startTime.getSeconds(),
      startTime.getMilliseconds(),
    );

    const endDateTime = new Date(endDate);
    endDateTime.setHours(
      endTime.getHours(),
      endTime.getMinutes(),
      endTime.getSeconds(),
      endTime.getMilliseconds(),
    );

    if (endDateTime <= startDateTime) {
      return {
        dateAndTimeAfter: {
          label:
            'GENERIC_VALIDATION.DEPARTURE_DATE_CANNOT_BE_AFTER_ARRIVAL_DATE',
        },
      };
    }
    return null;
  };
}

@formModel({
  validator: [dateAndTimeAfter('startDate', 'startTime', 'endDate', 'endTime')],
})
export class ConfigModelForm {
  @formField({ validators: Validators.required })
  public workingYear!: number | null;

  @formField({ validators: Validators.required })
  public startTime!: Date | null;

  @formField({ validators: Validators.required })
  public startDate!: Date | null;

  @formField({ validators: Validators.required })
  public endTime!: Date | null;

  @formField({ validators: Validators.required })
  public endDate!: Date | null;
}
